import Hint from './hint';

export default Hint;



// WEBPACK FOOTER //
// ./src/components/elements/hint/index.js